import { cache } from 'react';
import { Locale } from '@headless-workspace/config';
import { DI, NewsletterSlotRepositoryType } from '../../../DI';

export const getMemoNewsletterSlot = cache(async (locale: Locale) => {
    return DI.get(NewsletterSlotRepositoryType).fetchNewsletterSlot(locale);
});
